module.exports = __webpack_public_path__ + "static/media/sound-off.28830b26.svg";